


import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetMapLegend, GetMapLegendResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<GetMapLegendResponse, GetMapLegendResponse>) => response?.data?.legendItems;
const getError = (response?: SWRResponse<GetMapLegendResponse, GetMapLegendResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetMapLegendResponse, GetMapLegendResponse>) => ({});

const useGetMapLegend = (query?: Partial<GetMapLegend>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetMapLegend(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetMapLegend;